import { put, select } from 'redux-saga/effects';
import { selectLanguage } from 'redux/selectors/config';
import decisionTreeActions from 'redux/actions/decisionTreeActions';
import {
  getAllQuestions,
  getProductId,
} from './common-decision-tree-logic-saga';
import {
  currentDecisionTreeSelector,
  currentDTAnswersSelector,
  currentDTSelector,
} from 'redux/selectors/localDecisionTree';
import decisionTreeCurrentStepActions from 'redux/actions/decisionTreeCurrentStepActions';
import localDecisionTreeActions from 'redux/actions/localDecisionTreeActions';
import { moveToPreviousStep } from 'redux/actions/stepActions';
import { DecisionTreeType } from 'ts/types/decision-tree.types';
import { getCategoryAndIcon } from './decision-tree-receiver-saga';
const { getQuestionsDecisionTree } = decisionTreeActions;
const { getCurrentDTOptions, updateCurrentDecisionTree } =
  decisionTreeCurrentStepActions;
const {
  addStepToCurrentDTPath,
  removeStepFromCurrentDTPath,
  restoreLastDecisionTree,
  UpdateCurrentIcon,
} = localDecisionTreeActions;

export function* getFirstQuestionsSaga() {
  yield put(getCurrentDTOptions());
}

export function* getNextQuestionsSaga({
  payload: { answer, displayName, question },
}) {
  const currentDT = yield select(currentDecisionTreeSelector);
  const currentPath = yield select(currentDTAnswersSelector);
  const currentStep = currentPath
    .map(({ value }) => value)
    .reduce((acc, cur) => acc.givenAnswers[cur], currentDT);
  const localNodeOfDT = currentStep?.givenAnswers?.[answer]?.nextQuestion;
  const isTheAnswerAlreadyGotten = !!localNodeOfDT;

  if (isTheAnswerAlreadyGotten) {
    yield put(
      updateCurrentDecisionTree({
        nextQuestion: localNodeOfDT,
      }),
    );
    yield put(
      addStepToCurrentDTPath({
        id: currentStep.nextQuestion.id,
        value: answer,
        questionText: question,
        answerText: displayName,
      }),
    );
  } else {
    yield sendToDecisionTree({ answer, question, displayName });
  }
  if (answer) {
    const extraData = yield getCategoryAndIcon(answer);
    yield put(UpdateCurrentIcon(extraData));
  }
}
function* restoreLastStepOnCurrentPath(currentPath) {
  const currentDT = yield select(currentDecisionTreeSelector);
  const previousStep = currentPath
    .map(({ value }) => value)
    .reduce((acc, cur) => acc.givenAnswers[cur], currentDT);
  yield put(
    updateCurrentDecisionTree({
      nextQuestion: previousStep.nextQuestion,
    }),
  );
  yield put(removeStepFromCurrentDTPath());
}

export function* getPreviousQuestionsSaga() {
  const currentDTType = yield select(currentDTSelector);
  const currentPath = yield select(currentDTAnswersSelector);
  if (currentPath.length) {
    yield restoreLastStepOnCurrentPath(currentPath.slice(0, -1));
  } else if (currentDTType === DecisionTreeType.DIAGNOSIS) {
    yield put(moveToPreviousStep());
  } else {
    yield put(restoreLastDecisionTree());
    const updatedCurrentPath = yield select(currentDTAnswersSelector);
    yield restoreLastStepOnCurrentPath(updatedCurrentPath.slice(0, -1));
  }
}

export function* sendToDecisionTree({ answer, question, displayName, match }) {
  const state = (yield getAllQuestions({ answer, question })).map(
    ({ id, value }) => ({ id, value }),
  );
  const language = yield select(selectLanguage);
  const productId = yield getProductId();
  const line_ref = 'line_ref';
  yield put(
    getQuestionsDecisionTree({
      language,
      lines: [{ state, line_ref }],
      productId,
      question,
      displayName,
      match,
    }),
  );
}
